import React, { useEffect, useState } from 'react';
import HomePageTemplate from './home-page.template';
import { getActiveProductDataAPI, getCategoryDataApi, getInventorySearchAPI, getProductDataAPI } from './home-page.component.service';
import { storeCategories } from "../../reducers/app.reducer";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const HomePageComponent = () => {
    const [activeTab, setActiveTab] = useState("resource");
    const [inventoryItems, setInventoryItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [products, setProducts] = useState([]);
    // const dispatch = useDispatch();
    const { categories } = useSelector((state) => state.app);
    const navigate = useNavigate();

    const onLoad = async () => {
        try {
            setLoading(true);
            const response = await getActiveProductDataAPI();
            console.log("product response", response);
            if (response.status) {
                setProducts(response.data);
            } else {
                setError(response.message || "Failed to fetch products");
            }
            
        } catch (error) {
            setError(error.message || "An error occurred while fetching products");
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (payload) => {
        setSearchKeyword(payload.keyword || "");
        // fetchInventoryItems(payload);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    const handleProductClick = (slug) => {
    navigate(`/product-list/${slug}`);
  };

    useEffect(() => {
        onLoad();
    }, []);

    // console.log({products});

    const templateData = {
        activeTab,
        inventoryItems,
        loading,
        error,
        searchKeyword,
        products,
        categories,
    };

    const templateEvents = {
        handleSearch,
        handleTabChange,
        handleProductClick,
    };

    return <HomePageTemplate 
        templateData={templateData}
        templateEvent={templateEvents}
    />;
};

export default HomePageComponent;